import { render, staticRenderFns } from "./NavTop.vue?vue&type=template&id=2e453c02&scoped=true"
import script from "./NavTop.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavTop.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NavTop.vue?vue&type=style&index=0&id=2e453c02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e453c02",
  null
  
)

export default component.exports